import moment from "moment";

// Feb. 5, 2026
export function formatShortDate(date) {
  if (!date) return "—";

  return moment(date).utcOffset(8).format("MMM. D, YYYY");
}

// Thursday, February 5, 2026 3:00 PM
export function formatLongDateTime(date) {
  if (!date) return "—";

  return moment(date).utcOffset(8).format("dddd, MMMM D, YYYY h:mm A");
}

// Time only: 10:00 AM
export function formatTime(time) {
  if (!time) return "—";
  return moment(`1970-01-01T${time}`).format("h:mm A");
}

// February 2026
export function formatMonthYear(date) {
  if (!date) return "—";
  return moment(date).format("MMMM YYYY");
}

// Pinaninding Elementary School
export function toTitleCase(str) {
  if (!str) return "—";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
